import styles from './Table.module.scss';
import React, { FC, ReactNode } from 'react';
// import { Table as BootstrapTable } from 'react-bootstrap';
import { StringHelper } from '../../../../common/helpers/string-helper';

interface ITableProps {
	children: ReactNode;
	className?: string;
}

const Table: FC<ITableProps> = ({ children, className }) => {
	return (
		<table className={`${styles.table}${className ? ` ${className}` : StringHelper.Empty}`}>
			{children}
		</table>
	);
};

export default Table;
